
























































































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import {
  ScheduleCalendarMode, Schedule, TutorSelector, ScheduleRequest, ScheduleMoveMode
} from '@/modules/schedule';
import { Tutor } from '@/modules/tutor';
import { ElForm } from 'element-ui/types/form';
import { Subject } from '@/models/subject';
import { Person } from '@/models/person';
import { ReportCreateArgs } from '@/modules/reservation';

interface RequestRules {
  scheduleId: object[];
  tutorId: object[];
  weekday: object[];
  date: object[];
  stringStart: object[];
  stringEnd: object[];
  subjectIds: object[];
  capacity: object[];
  memo: object[];
}

@Component({})
export default class extends Vue {
  private ScheduleMoveMode = ScheduleMoveMode;

  private shownTime = new Date().getTime();

  private get dialogClass() {
    if (this.isMove) {
      return 'move';
    }
    if (this.isCopy) {
      return 'copy';
    }
    return undefined;
  }

  private get confirmButtonType() {
    if (this.isMove) {
      return 'success';
    }
    if (this.isCopy) {
      return 'warning';
    }
    return 'primary';
  }

  private get moveModeRadioButtonColor() {
    if (this.isMove) {
      return '#67C23A';
    }
    return '#E6A23C';
  }

  private get title() {
    if (this.isBaseScheduleMode) {
      if (this.isMove) {
        return '基本スケジュールの移動';
      }
      if (this.isCopy) {
        return '基本スケジュールのコピー';
      }
      return '基本スケジュールの' + (this.formData && this.formData.scheduleId ? '編集' : '追加');
    }
    if (this.isTempCalendarMode || this.isCalendarMode) {
      if (this.isMove) {
        return '予約枠の移動';
      }
      if (this.isCopy) {
        return '予約枠のコピー';
      }
      return '予約枠の' + (this.formData && this.formData.scheduleId ? '編集' : '追加');
    }
    if (this.isReservationMode) {
      return '予約の詳細';
    }
    return '';
  }

  private get confirmButtonText() {
    if (this.isMove) {
      return '移動';
    }
    if (this.isCopy) {
      return 'コピー';
    }
    return '確認';
  }

  private get tutor(): TutorSelector | undefined {
    return this.tutors.find((value: TutorSelector) => {
      return value.tutorId === this.formData.tutorId;
    });
  }

  private get subjects(): Subject[] {
    if (this.tutor === undefined) { return []; }
    return this.tutor.enableSubjects.filter((subject: Subject) => {
      return this.formData.subjectIds.find((id: number) => {
        return id === subject.id;
      }) !== undefined;
    });
  }

  private get isCreate() {
    return !this.formData.scheduleId;
  }

  private get isBaseScheduleMode(): boolean {
    return this.mode === ScheduleCalendarMode.BaseSchedule;
  }

  private get isTempCalendarMode(): boolean {
    return this.mode === ScheduleCalendarMode.TempCalendar;
  }

  private get isCalendarMode(): boolean {
    return this.mode === ScheduleCalendarMode.Calendar;
  }

  private get isReservationMode(): boolean {
    return this.mode === ScheduleCalendarMode.Reservation;
  }

  private get isMoveOrCopy(): boolean {
    switch (this.localMoveMode) {
      case ScheduleMoveMode.Move:
      case ScheduleMoveMode.Copy:
      case ScheduleMoveMode.CopyAndBeforeEdit:
        return true;
      default:
        return false;
    }
  }

  private get isMove(): boolean {
    switch (this.localMoveMode) {
      case ScheduleMoveMode.Move:
        return true;
      default:
        return false;
    }
  }

  private get isCopy(): boolean {
    switch (this.localMoveMode) {
      case ScheduleMoveMode.Copy:
      case ScheduleMoveMode.CopyAndBeforeEdit:
        return true;
      default:
        return false;
    }
  }

  private pickerOptions = {
    disabledDate: (value: Date) => {
      if (!this.targetYearMonth) {
        return false;
      }
      return value.getFullYear() !== this.targetYearMonth.getFullYear()
        || value.getMonth() !== this.targetYearMonth.getMonth();
    },
  };

  private readonly WEEKDAYS = [ '日', '月', '火', '水', '木', '金', '土' ];
  private isLoading = false;
  private readonly REQUEST_RULE: RequestRules = {
    scheduleId: [],
    tutorId: [{ required: !this.isReservationMode, message: '講師は必須項目です。', trigger: 'blur' }],
    weekday: [{ required: !this.isReservationMode, message: '曜日は必須項目です。', trigger: 'blur' }],
    date: [{ required: !this.isReservationMode, message: '日付は必須項目です。', trigger: 'blur' }],
    stringStart: [
      {
        required: !this.isReservationMode,
        message: '開始時刻は必須項目です。',
        trigger: 'blur'
      },
      {
        validator: (rule: any, value: any, callback: any) => {
          (this.$refs.form as any).validateField('stringEnd');
          callback();
        },
        trigger: 'blur'
      },
    ],
    stringEnd: [
      {
        required: !this.isReservationMode,
        message: '終了時刻は必須項目です。',
        trigger: 'blur'
      },
      {
        validator: (rule: any, value: any, callback: any) => {
          if (this.dateEnd !== null && this.dateStart !== null) {
            if (this.dateStart > this.dateEnd) {
              callback(new Error('終了時刻を開始時刻より前に設定できません'));
              return;
            }
          }
          callback();
        },
        trigger: 'blur'
      },
    ],
    subjectIds: [{ required: !this.isReservationMode, message: '教科は必須項目です。', trigger: 'blur' }],
    capacity: [{ required: !this.isReservationMode, message: '定員は必須項目です。', trigger: 'blur' }],
    memo: [],
  };

  @Prop({required: true})
  private isActive!: boolean;
  private isVisible = this.isActive;

  @Prop({required: true})
  private form!: ScheduleRequest;
  private get formData(): ScheduleRequest {
    return this.form;
  }
  private set formData(value: ScheduleRequest) {
    this.$emit('update:form', value);
  }

  @Prop({required: true})
  private tutors: TutorSelector[];

  @Prop({required: true})
  private reservers: Person[];

  // HACK: 本来の型は ScheduleCalendarMode。enum を指定するとそれは number だってエラー出るので number 定義しておきます。
  @Prop({required: true})
  private mode: number;

  @Prop({required: true})
  private moveMode: number;

  @Prop({required: false, type: Date, default: () => null})
  private targetYearMonth: Date | null;

  get localMoveMode(): ScheduleMoveMode {
    return this.moveMode;
  }
  set localMoveMode(value: ScheduleMoveMode) {
    this.$emit('update:moveMode', value);
  }

  private prevScheduleId = 0;

  @Watch('isActive')
  private onChangedIsActive() {
    this.isVisible = this.isActive;

    if (this.isActive) {
      if (this.$refs.form) {
        (this.$refs.form as ElForm).resetFields();
      }

      this.$nextTick(() => {
        if (!this.formData.scheduleId) {
          this.onChangedTutorId();
        }
      });
    }
  }
  @Watch('isVisible')
  private onChangedIsVisible() {
    this.shownTime = new Date().getTime();
    (this.$refs.form as ElForm)?.clearValidate();

    this.$emit('update:isActive', this.isVisible);
  }

  private get dateStart(): Date | null {
    if (this.formData.stringStart) {
      const nowDate = !this.formData.date ? new Date() : this.formData.date;
      const splitTime = this.formData.stringStart.split(':');
      return new Date(
        nowDate.getFullYear(),
        nowDate.getMonth(),
        nowDate.getDate(),
        parseInt(splitTime[0], 10),
        parseInt(splitTime[1], 10)
      );
    } else {
      return null;
    }
  }
  private set dateStart(value: Date | null) {
    if (value) {
      this.formData.stringStart = value.getHours().toString() + ':' + value.getMinutes().toString();
    } else {
      this.formData.stringStart = '';
    }
    (this.$refs.form as ElForm).validateField('stringStart', () => undefined);
  }

  private get dateEnd(): Date | null {
    if (this.formData.stringEnd) {
      const nowDate = !this.formData.date ? new Date() : this.formData.date;
      const splitTime = this.formData.stringEnd.split(':');
      return new Date(
        nowDate.getFullYear(),
        nowDate.getMonth(),
        nowDate.getDate(),
        parseInt(splitTime[0], 10),
        parseInt(splitTime[1], 10)
      );
    } else {
      return null;
    }
  }
  private set dateEnd(value: Date | null) {
    if (value) {
      this.formData.stringEnd = value.getHours().toString() + ':' + value.getMinutes().toString();
    } else {
      this.formData.stringEnd = '';
    }
    (this.$refs.form as ElForm).validateField('stringEnd', () => undefined);
  }

  private onChangedTutorId() {
    if (this.prevScheduleId === this.formData.scheduleId) {
      this.formData.subjectIds = [];
      if (this.tutor !== undefined) {
        this.tutor.enableSubjects.forEach((subject: Subject) => {
          this.formData.subjectIds.push(subject.id);
        });
      }
    }
    this.prevScheduleId = this.formData.scheduleId;
  }

  private remove() {
    (this as any).$confirm('スケジュールを削除します。よろしいですか？', '削除確認', {
      confirmButtonText: 'はい',
      cancelButtonText: 'いいえ',
      type: 'warning'
    })
    .then(async () => {
      this.isLoading = true;

      await this.$emit('remove', this.formData.scheduleId);

      this.isVisible = false;
      this.isLoading = false;
    })
    .catch();
  }

  private cancel() {
    this.$emit('cancel', this.formData);
    this.isVisible = false;
  }

  private send() {

    // バリデーション
    (this.$refs.form as ElForm).validate((valid) => {
      if (valid) {

        (this as any).$confirm('入力情報で確定します。よろしいですか？', '送信確認', {
          confirmButtonText: 'はい',
          cancelButtonText: 'いいえ',
          type: 'warning'
        })
        .then(async () => {
          this.isLoading = true;

          switch (this.localMoveMode) {
            case ScheduleMoveMode.Move:
              await this.$emit('move', this.formData);
              break;
            case ScheduleMoveMode.Copy:
            case ScheduleMoveMode.CopyAndBeforeEdit:
              await this.$emit('copy', this.formData);
              break;
            default:
              await this.$emit('send', this.formData);
              break;
          }

          this.isVisible = false;
          this.isLoading = false;
        })
        .catch();
      }
      return valid;
    });
  }

  private makeReport() {
    const schedule: Schedule = this.$store.getters['calendar/getSchedule'](this.formData.scheduleId);
    if (!schedule) {
      return;
    }
    const argsList: ReportCreateArgs[] = schedule.reservers.map((person) => ({
      studentId: person.id,
      studentName: person.name,
      startDate: this.dateStart,
      endDate: this.dateEnd,
      subjects: [person.subject]
    }));

    if (argsList.length > 0) {
      this.$store.commit('reservation/setReportCreateArgsList', argsList);
    } else {
      this.$store.commit('reservation/setReportCreateArgsList', [
        {
          startDate: this.dateStart,
          endDate: this.dateEnd,
          subjects: this.subjects,
        }
      ] as ReportCreateArgs[]);
    }
    this.$router.push({ name: 'ReportCreate' });
  }

  private remaining(capacity: number, reserverNumber: number) {
    const ret = capacity - reserverNumber;
    return ret >= 0 ? ret : 0;
  }

  private gotoStudentDetail(id: string) {
    this.$emit('click-reserver-name', id, this.formData.scheduleId);
  }

  private clickAddReserver() {
    const message = (this.isBaseScheduleMode || this.isTempCalendarMode) ?
      'こちらの画面では、定員数、学年、受講教科、予約コマ数の制限を無視して設定することができます。' :
      'こちらの画面では、定員数、学年、受講教科、予約コマ数の制限を無視して予約することができます。';
    this.$alert(message, '注意', {
      type: 'warning',
      confirmButtonText: 'OK',
    }).then(() => {
      this.$emit('click-add-reserver', this.formData.scheduleId);
    });
  }
}
